import { useTranslation } from 'react-i18next';

import { getRouteApi } from '@tanstack/react-router';
import { LayoutGrid, List, MapPin } from 'lucide-react';

import { Button } from '@/components/new-ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/new-ui/dropdown-menu';

import { ESTATES_TOOLBAR_ROUTES } from '../constants/routes';

const route = getRouteApi(ESTATES_TOOLBAR_ROUTES.ESTATES);

type ViewMode = 'list' | 'grid' | 'map';

const VIEW_ICONS: Record<ViewMode, typeof List> = {
  list: List,
  grid: LayoutGrid,
  map: MapPin,
};

const VIEW_ORDER: ViewMode[] = ['grid', 'list', 'map'];

/** View mode dropdown of the estates page, writes `view` to the URL. */
export const EstatesViewMenu = () => {
  const { t } = useTranslation();
  const search = route.useSearch();
  const navigate = route.useNavigate();
  const view = (search.view || 'list') as ViewMode;
  const CurrentIcon = VIEW_ICONS[view];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" className="gap-2" aria-label={t('view')}>
          <CurrentIcon className="h-4 w-4" />
          <span className="hidden sm:inline">{t(view)}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="z-50 border border-border bg-background shadow-lg"
      >
        {VIEW_ORDER.filter((mode) => mode !== view).map((mode) => {
          const Icon = VIEW_ICONS[mode];
          return (
            <DropdownMenuItem
              key={mode}
              className="cursor-pointer gap-2"
              onSelect={() => {
                navigate({ search: (prev) => ({ ...prev, view: mode }), replace: true });
              }}
            >
              <Icon className="h-4 w-4" /> {t(mode)}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
